<template>
  <Message class="text-center alert" :closable="false">
    <template #messageicon>
      <i class="bx bx-purchase-tag"></i>
    </template>
    <div class="center-tags" v-if="postTags.length">
      <router-link
        v-for="(tag, index) in postTags"
        :key="index"
        :to="`/tags/${tag}`"
        class="tag-btn"
      >
        {{ tag }}
      </router-link>
    </div>
    <div v-else>
      <p>This post does not have any tags yet!</p>
    </div>
  </Message>
</template>

<script>
import Message from 'primevue/message'

export default {
  name: 'PostTags',
  props: [
    'postTags'
  ],
  components: {
    Message
  }
}
</script>

<style scoped>
.center-tags {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-btn {
  padding: 4px 12px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  background: rgba(0,0,0,0.05);
  transition: background 0.2s;
}

.tag-btn:hover {
  background: rgba(0,0,0,0.1);
}

.alert {
  margin-bottom: 50px;
}
</style>
